import { atomWithStorage } from "jotai/utils";

export const onboardingSteps = [
  "welcome",
  "selectHealthAreas",
  "userSegmentation",
  "referralSource",
  "featureOverview",
  "calendarSetup",
  "signup",
  "profileSetup",
  "createRoutine",
  "notificationsSetup",
  "paywall",
  "completed",
] as const;

export type OnboardingStep = (typeof onboardingSteps)[number];

export type Onboarding = {
  step: OnboardingStep;
  open: boolean;
  selectedHealthAreas: string[];
  userSegments: string[];
  referralSource: string;
  timeFormat: "12h" | "24h";
  weekStartsOn: 0 | 1; // 0 = Sunday, 1 = Monday
  timezone: string;
  featureOverviewSlide: number;
};

export const initialOnboarding: Onboarding = {
  step: "welcome",
  open: true,
  selectedHealthAreas: [],
  userSegments: [],
  referralSource: "",
  timeFormat: "24h",
  weekStartsOn: 1,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  featureOverviewSlide: 0,
};

export const onboardingAtom = atomWithStorage<Onboarding>("onboarding", initialOnboarding);
